export default "__VITE_ASSET__b8392d98__"